// ---------------------------------------------------------------------------
// CLINIC CONTENT — single source of truth. To update the website, edit the
// values below (name, address, phone, hours, map/WhatsApp links). Every
// section of the site reads from this file, so one edit updates all pages.
// ---------------------------------------------------------------------------
export const SITE_URL = process.env.REACT_APP_SITE_URL;

export const CLINIC = {
    name: "Agastya Chiro and Ancient Marma Therapy",
    shortName: "Agastya Chiro & Ancient Marma Therapy",
    tagline: "Traditional Wellness • Marma Chikitsa • Holistic Care",
    phoneDisplay: "89781 33934",
    phoneIntl: "+91 89781 33934",
    phoneTel: "tel:+918978133934",
    whatsapp:
        "https://wa.me/918978133934?text=Namaste!%20I%20would%20like%20to%20book%20a%20consultation%20at%20Agastya%20Chiro%20and%20Ancient%20Marma%20Therapy%2C%20Kurnool.",
    addressLines: [
        "H.No: 87-1299, Road No. 6A,",
        "Nagi Reddy Revenue Colony,",
        "Near Vastralaya Mall,",
        "Kurnool, Andhra Pradesh – 518002",
    ],
    addressShort: "Nagi Reddy Revenue Colony, Kurnool, Andhra Pradesh",
    hours: {
        weekdays: "Monday – Saturday: 9:00 AM – 6:00 PM",
        sunday: "Sunday: Closed",
        short: "Mon–Sat, 9 AM – 6 PM",
    },
    mapsEmbed:
        "https://www.google.com/maps?q=Agastya%20Chiro%20and%20Ancient%20Marma%20Therapy%2C%20Nagi%20Reddy%20Revenue%20Colony%2C%20Kurnool%2C%20Andhra%20Pradesh%20518002&output=embed",
    mapsDirections:
        "https://www.google.com/maps/dir/?api=1&destination=Agastya%20Chiro%20and%20Ancient%20Marma%20Therapy%2C%20Nagi%20Reddy%20Revenue%20Colony%2C%20Kurnool%2C%20Andhra%20Pradesh%20518002",
    mapsView:
        "https://www.google.com/maps/search/?api=1&query=Agastya%20Chiro%20and%20Ancient%20Marma%20Therapy%2C%20Kurnool%2C%20Andhra%20Pradesh",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxheXVydmVkaWMlMjBtYXNzYWdlJTIwdGhlcmFweXxlbnwwfHx8fDE3OTA0MzE0OTN8MA&ixlib=rb-4.1.0&q=80&w=1600&auto=format&fit=crop",
    marmaTherapy:
        "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxheXVydmVkaWMlMjBtYXNzYWdlJTIwdGhlcmFweXxlbnwwfHx8fDE3OTA0MzE0OTN8MA&ixlib=rb-4.1.0&q=80&w=1000&auto=format&fit=crop",
    ayurvedicHerbs:
        "https://images.unsplash.com/photo-1545840716-c82e9eec6930?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxlc3NlbnRpYWwlMjBvaWxzJTIwaGVyYnN8ZW58MHx8fHwxNzkwNDMxNDkyfDA&ixlib=rb-4.1.0&q=80&w=900&auto=format&fit=crop",
    essentialOils:
        "https://images.unsplash.com/photo-1676852148076-7a92002419f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxlc3NlbnRpYWwlMjBvaWxzJTIwaGVyYnN8ZW58MHx8fHwxNzkwNDMxNDkyfDA&ixlib=rb-4.1.0&q=80&w=900&auto=format&fit=crop",
    yogaMeditation:
        "https://images.unsplash.com/photo-1545389336-cf090694435e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHx5b2dhJTIwbWVkaXRhdGlvbiUyMG5hdHVyZXxlbnwwfHx8fDE3OTA0MzE0OTN8MA&ixlib=rb-4.1.0&q=80&w=900&auto=format&fit=crop",
    physiotherapy:
        "https://images.unsplash.com/photo-1649751361457-01d3a696c7e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxwaHlzaW90aGVyYXB5JTIwY2xpbmljfGVufDB8fHx8MTc5MDQzMTQ5Mnww&ixlib=rb-4.1.0&q=80&w=900&auto=format&fit=crop",
    acupuncture:
        "https://images.unsplash.com/photo-1598555763574-dca77e10427e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxhY3VwdW5jdHVyZSUyMHRoZXJhcHl8ZW58MHx8fHwxNzkwNDMxNDkyfDA&ixlib=rb-4.1.0&q=80&w=900&auto=format&fit=crop",
    spaTexture:
        "https://images.unsplash.com/photo-1632012643865-dadda4f2d3cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxzcGElMjB0ZXh0dXJlJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3OTA0MzE0OTJ8MA&ixlib=rb-4.1.0&q=80&w=900&auto=format&fit=crop",
    reflexology:
        "https://images.unsplash.com/photo-1712638932314-e2b185ca0930?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxmb290JTIwcmVmbGV4b2xvZ3klMjBtYXNzYWdlfGVufDB8fHx8MTc5MDQzMTUwOHww&ixlib=rb-4.1.0&q=80&w=900&auto=format&fit=crop",
    taiChi:
        "https://images.unsplash.com/photo-1774618623731-bbbf59e4b6ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHx0YWklMjBjaGklMjBvdXRkb29yc3xlbnwwfHx8fDE3OTA0MzE1MDh8MA&ixlib=rb-4.1.0&q=80&w=900&auto=format&fit=crop",
};

export const NAV_LINKS = [
    { label: "Marma Chikitsa", id: "marma" },
    { label: "Benefits", id: "benefits" },
    { label: "Procedure", id: "procedure" },
    { label: "Marma Points", id: "marma-points" },
    { label: "Therapies", id: "therapies" },
];

export const PAGE_LINKS = [
    { label: "About", to: "/about", id: "about" },
    { label: "FAQ", to: "/faq", id: "faq" },
    { label: "Contact", to: "/contact", id: "contact" },
];
